<div class="LCS_calender-container">
  <input
    matInput
    [matDatepicker]
    [max]="maxDate"
    [min]="minDate"
    [value]="selectedDate"
    (dateChange)="dateInputChanged($event)"
    [matDatepicker]="picker"
    [matDatepickerFilter]="calenderAvailableFilter"
    placeholder="Choose a date"
    class="LCS_date-rng-input"
  />
  <mat-datepicker [panelClass]="['LCS_calender']" #picker (closed)="onDatePickerClose()" [startAt]="minDate"></mat-datepicker>
  <button class="btn btn-filter LCS_calender-btn" [ngClass]="{'active': isCalenderOpen}" type="button" (click)="picker.open(); isCalenderOpen = true">
    CALENDAR
  </button>
</div>